export const config = [
  {
    texts: {
      header: "CS_SEARCH_RESULTS",
      actionButtonLabel: "Select",
    },
    labels: [
      {
        label: "Amount Due",
        key: "total_due",
        noteStyle: {
          fontSize: "24px",
          fontWeight: "bold",
        },
        notePrefix: "₹ ",
      },
      {
        label: "Property ID",
        key: "property_id",
      },
      {
        label: "Owner's Name",
        key: "owner_name",
      },
      {
        label: "Address",
        key: "property_address",
      },
      {
        label: "Status",
        key: "status",
      },
    ],
  },
];
